import { deepMerge } from "./deepMerge";

export function applyTenantOverride(baseResources, overrideKey, loader) {
  if (!overrideKey) return baseResources;

  const result = {};
  for (const lang of Object.keys(baseResources)) {
    const overrideJson = loader(overrideKey, lang);
    result[lang] = {
      translation: deepMerge(
        baseResources[lang].translation,
        overrideJson || {}
      ),
    };
  }
  return result;
}

export function defaultOverrideLoader(overrideKey, lang) {
  try {
    return require(`./locales/overrides/${overrideKey}/${lang}.json`);
  } catch (e) {
    return null;
  }
}
